(ns bec-cljs-common.networking
  (:require [ajax.core :as ajax]
            [re-frame.core :as rf] ;; TODO: https://gitlab.com/bulls-eye/bec-cljs-common/-/issues/2
            [editscript.core :as editscript]
            [cljs.pprint]
            [taoensso.timbre :as log]
            [lambdaisland.uri :as uri]
            [bec-data-format.core :as bec-df]
            [bec-cljs-common.config :as config]))


;; NOTE: Should sort of match bec-clj-common.state-sync-server/mk-client-url. We should consider merging bec-clj-common and bec-cljs-common at some point - and use .cljc files ( https://clojure.org/guides/reader_conditionals ).
(defn sse-url [stream-name conn-id op & args]
  (let [args (apply hash-map args)] ;; TODO: Switch to `& {:as args}` when CLJS gets CLJ 1.11.x style support for this.
    (-> (uri/uri (str "/bec-clj-common/state-sync-server"
                      "/" op
                      "/" stream-name))
        (uri/assoc-query :app-category (pr-str (or (:app-category args) config/app-category))
                         :app-type (pr-str (or (:app-type args) config/app-type))
                         :device-id (pr-str (or (:device-id args) config/device-id))
                         :session-id (pr-str (or (:session-id args) config/session-id))
                         :viewport-id (pr-str (or (:viewport-id args) config/viewport-id))
                         :conn-id (pr-str conn-id) ;; Tends to be config/viewport-id in the current game-related apps, but might not be.
                         :state-paths (pr-str (or (:state-paths args) [[]])))
        (str))))


(defn start-sse "Starts SSE connection with server at `stream-url`.
  `client-state-path`: Used to route state updates to a sub-map; i.e. (update-in .. client-state-path ..). Can be NIL or an empty? coll which will mean that the state will be synced at the top-level."
  [client-state-path stream-url resync-cb]
  (let [sse (js/EventSource. stream-url #js {"withCredentials" "true"})]
    (.addEventListener sse "open" #(rf/dispatch [:assoc-in [::sse-connected?] true]))
    ;; "Some" HTTP responses (e.g. 5xx) will lead to a situation where EventSource doesn't automatically reconnect(!).
    (.addEventListener sse "error"
                       (fn []
                         (rf/dispatch [:assoc-in [::sse-connected?] false])
                         (.close sse) ;; It's insane that JS will automatically retry for "some" error conditions, but not others -- so we close here to be consistent.
                         (js/setTimeout #(start-sse client-state-path stream-url resync-cb) 3000)))
    (.addEventListener sse "message"
                       #(let [raw-msg (bec-df/unpack (-> % .-data))
                              raw-data (:data raw-msg), raw-msg-counter (:message-counter raw-msg)]
                          #_(log/report 'raw-msg raw-msg)
                          (if-let [event (:event raw-data)]
                            (let [data (:data raw-data)] ;; "data -> event-data"
                              ;; TODO/NOTE: Disabled https://github.com/binaryage/cljs-devtools formatted output for now, because the extra nesting after a protocol change means we'll have to click a lot to expand and see even small "patch" messages. Very stupid.
                              (log/debug data)
                              ;; TODO: We should handle raw-msg-counter locally instead -- as it is a protocol detail.
                              (rf/dispatch [::sse-message event data raw-msg-counter client-state-path resync-cb]))
                            (log/fatal "Got unknown message:" raw-msg))))
    sse))


(def ^:const msg-count-mod 1000000) ;; NOTE: Value must match state-sync-server/msg-count-mod.


(defn message-count-handler "Returns `db` when things are OK or false when resync has started."
  [db event curr-count resync-cb]
  (assert curr-count)
  (let [prev-count (if (= "resync" event)
                     (dec curr-count)
                     (::message-counter db))]
    (if (not= (mod (inc prev-count) msg-count-mod)
              curr-count)
      (do
        (log/warn "Resyncing state with server:" {:prev-count prev-count, :curr-count curr-count})
        (resync-cb)
        false)
      (assoc db ::message-counter curr-count))))

(rf/reg-event-db ::sse-message
  (fn [db [_ event data raw-msg-counter client-state-path resync-cb]]
    (try
      (if-let [db (message-count-handler db event raw-msg-counter resync-cb)]
        (case event
          "patch"
          (reduce (fn [db [server-state-path diff]]
                    (let [path (concat client-state-path server-state-path)]
                      #_(log/debug "patch" {:path path, :diff diff})
                      (if (empty? path)
                        (editscript/patch db (editscript.edit/edits->script diff))
                        (update-in db path editscript/patch (editscript.edit/edits->script diff)))))
                  db data)

          "resync"
          (-> (reduce (fn [db [server-state-path data]]
                        (let [path (concat client-state-path server-state-path)]
                          #_(log/debug "resync" {:path path, :data data})
                          (if (empty? path)
                            (merge db data) ;; FIXME: This should just return `data` as is, but we can't do this for AC, CC and MC for now. See https://gitlab.com/bulls-eye/darts-game-server/-/issues/100
                            (assoc-in db path data))))
                      db data)
              (assoc ::initialized? true)))
        db)  ;; IF-LETs false clause doesn't rebind `db` -- we're ignoring the message because we're out of sync anyway.
      (catch :default ex
        (log/fatal (ex-info (str ex) {:event event, :data data, :client-state-path client-state-path} ex))
        db))))


(defn local? []
  (let [hostname (.. js/window -location -hostname)]
    (or (= "127.0.0.1" hostname)
        (= "localhost" hostname))))
